import React from 'react';
import { Dialog } from '@mui/material';

// Dialogs close only through an explicit action button. Backdrop taps and
// Escape must never discard forms, confirmations, or room state by accident.
export default function ActionDialog({ onClose, ...props }) {
    const handleClose = (event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
        onClose?.(event, reason);
    };
    return <Dialog {...props} disableEscapeKeyDown onClose={handleClose} />;
}
